<template>
  <resend-confirmation-email-main />
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class ResendConfirmationEmailPage extends Vue {}

export default toNative(ResendConfirmationEmailPage)
</script>
